import {
	PUR5020_R01DetailDto,
	PUR5020_R01HeaderDto,
} from "src/containers/mes/PUR/PUR5020_R01/Dto_PUR5020_R01";
import { ResponseDto } from "src/dtos/common/responseDto";
import config from "src/config";
import { getData } from "src/utils/axios/serverHelper";
import { PUR5020_R01Filter } from "./Store_PUR5020_R01";

const baseUrl = `${config.apiUrl}/PUR5020_R01`;

/**
 * 재고수불장 재고 현황 목록 조회 (GET)
 */
export const getPUR5020_R01List = async (option: string, params: Partial<PUR5020_R01Filter>, listLength: number = 0) => {
	const normalizedOption = option && option.trim().length > 0 ? option : 'search';
	const url = `${baseUrl}/${normalizedOption}`;
	return await getData<ResponseDto<PUR5020_R01HeaderDto[]>>(url, {
		params: {
			...params,
			listLength
		}
	});
};

export const getPUR5020_R01AllCount = async (params: Partial<PUR5020_R01Filter>) => {
	const url = `${baseUrl}/allCount`;
	return await getData<ResponseDto<number>>(url, {
		params: {
			...params
		}
	});
};

/**
 * 재고수불장 수불 이력 목록 조회 (GET)
 */
export const getDetailPUR5020_R01List = async (params: Partial<PUR5020_R01Filter>, listLength: number = 0) => {
	const url = `${baseUrl}/detail`;
	return await getData<ResponseDto<PUR5020_R01DetailDto[]>>(url, {
		params: {
			...params,
			listLength
		}
	});
};

/**
 * 수불 이력 엑셀 다운로드 (GET)
 */
export const downloadDetailExcel_PUR5020_R01 = async (option: string, params: Partial<PUR5020_R01Filter>, listLength: number = 0) => {
	const normalizedOption = option && option.trim().length > 0 ? option : 'search';
	const url = `${baseUrl}/excel/${normalizedOption}`;
	return await getData<ResponseDto<ArrayBuffer>>(url, {
		params: {
			...params,
			listLength
		}
	});
};
